export const messages = {
  page: {
    title: {
      id: 'education.Page.Title',
      defaultMessage: 'Education',
    },
    noArticles: {
      id: 'education.Page.NoArticles',
      defaultMessage: 'No items to display',
    },
    articlesPresentNoneSelected: {
      id: 'education.Page.ArticlesPresentNoneSelected',
      defaultMessage: 'Select an item from the list on the left.',
    },
    getPdfViewer: {
      id: 'education.Page.GetPdfViewer',
      defaultMessage: 'If you don\'t have a PDF viewer, download one at {link}',
    },
    linkHrefPdfViewer: {
      id: 'link.Href.PdfViewer',
      defaultMessage: 'https://get.adobe.com/reader/',
    },
    linkTextPdfViewer: {
      id: 'link.Text.PdfViewer',
      defaultMessage: 'https://get.adobe.com/reader/',
    },
    showArchived: {
      id: 'education.Page.ShowArchived',
      defaultMessage: 'Show archived ({ numArchived }) ',
    },
  },
  groupPanel: {
    title: {
      id: 'education.GroupPanel.Title',
      defaultMessage: 'Articles',
    },
    assignedOn: {
      id: 'education.GroupPanel.AssignedOn',
      defaultMessage: 'Assigned: {assignedDate}',
    },
  },
};

export const viewSelectionPreferences = [
  {
    id: 'education.ViewSelectionPreference.NewPage',
    key: 'NewTab',
    defaultMessage: 'Preview on a new page',
  },
  {
    id: 'education.ViewSelectionPreference.CurrentPage',
    key: 'InPage',
    defaultMessage: 'Preview on this page',
  },
];
